import { Observable ,  BehaviorSubject } from 'rxjs'
import { distinctUntilChanged } from 'rxjs/operators'

import { Injectable } from '@angular/core'

import { RouterService } from './router.service'


@Injectable()
export class KeyboardService {

  private keyboardResponseSubject = new BehaviorSubject<string>(null)
  public keyboardResponse = this.keyboardResponseSubject.asObservable().pipe(distinctUntilChanged())


  constructor(
    private routerService: RouterService
  ) {}

  handleKeyboardEvent(evt: KeyboardEvent) {
    console.log('handleKeyboardEvent', evt.keyCode, evt.key, evt.code)
    if (evt.keyCode === 27) return this.handleKeyEsc(evt)
  }

  handleKeyEsc(evt: KeyboardEvent) {
    let outlets = this.routerService.outlets()
    let keyRes

    if (outlets['p']) {
      keyRes = 'close-popup'
    } 
    // else if (outlets['l']) {
    //   keyRes = 'close-lightbox'
    // } else if (outlets['m']) {
    //   keyRes = 'esc-modal'
    // } else if (outlets['c']) {
    //   keyRes = 'close-collection'
    // }
    this.keyboardResponseSubject.next(keyRes)
    this.keyboardResponseSubject.next(null)
  }
}
